// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"285":"386a4ccf","458":"a411e780","631":"16eaec8c","774":"e41de6b9","819":"87dad1dc","851":"aa7d8168","858":"e669e5aa"}[chunkId] + ".chunk.js";
};